import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputDatepickerNewComponent } from '../../components/input-datepicker-new/input-datepicker-new.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import Toast from '../../services/toast.service';
import ServiceRestServices from '../../services/service-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-add-therapy-fund-wallet',
	templateUrl: './modal-add-therapy-fund-wallet.component.html',
	imports: [
		CommonModule, TranslatePipe, LoaderOverlayComponent, 
		InputDatepickerNewComponent, FormsModule, ItemErrorComponent
	]
})
export class ModalAddTherapyFundWalletComponent implements OnInit {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private toast: Toast = inject(Toast);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private dialogRef = inject(MatDialogRef<ModalAddTherapyFundWalletComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.submit = this.submit;
		this.vm.close = this.close;
		this.vm.wallet = {};
		this.vm.wallet.user = {};
		
		this.initialize();
	}
	
	initialize() {
		this.vm.loaderTimeout = this.angularHelperService.createTimer(
			() => { this.vm.processing = true; }, 
			this.config.getOtherConfig()['LOADER_TIMEOUT_INIT']
		);
		
		this.vm.uid = 'tw-' + Date.now();
		this.vm.user = this.session.getSession().user;
		this.vm.minDate = new Date(2020, 0, 1);
		this.vm.defaultStartDate = new Date();
		this.vm.defaultEndDate = moment().endOf("year").utcOffset(0, true).toDate();
		
		this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		if (this.vm.processing) {
			this.angularHelperService.createTimer(
				() => { this.vm.processing = false; }, 
				this.config.getOtherConfig()['LOADER_TIMEOUT_DELAY']
			);
		}
		
		this.serviceRestServices.getServiceOwnerTherapyFundSettings(
			(settings) => {
				if (settings && settings.therapyFundBalancePerPatient && settings.therapyFundBalancePerPatient > 0) {
					this.vm.wallet.balance = settings.therapyFundBalancePerPatient;
				}
				this.vm.initialized = true;
			},
			(error) => {
				console.log(error);
				this.vm.initialized = true;
			}
		);
	}
	
	submit(mainForm: any) {
		this.vm.personalCodeFailed = false;
		this.vm.submitted = true;
		if (mainForm.invalid || this.vm.processing || !this.vm.initialized) return;
		this.vm.processing = true;
		
		var wallet: any = {};
		wallet.user = {};
		wallet.user.personalCode = this.vm.wallet.user.personalCode;
		wallet.balance = this.vm.wallet.balance;
		if (this.vm.wallet.validFrom) {
			wallet.validFrom = moment(this.vm.wallet.validFrom).utcOffset(0, true).toDate();
		}
		if (this.vm.wallet.validTo) {
			wallet.validTo = moment(this.vm.wallet.validTo).utcOffset(0, true).toDate();
		}
		
		this.serviceRestServices.addTherapyFundWallet(wallet,
			(walletCreated) => {
				this.dialogRef.close(walletCreated);
				this.toast.showWithTranslation('TherapyFundWallet.AddingSuccess');
			},
			(error) => {
				console.log(error);
				this.vm.processing = false;
				if (error && error.error.length > 0 && error.error[0].property == 'User' && error.error[0].message == 'NotExists') {
					this.vm.personalCodeFailed = true;
					this.toast.showWithTranslation('TherapyFundWallet.UserNotFound');
				} else {
					this.toast.showWithTranslation('TherapyFundWallet.AddingFailed');
				}
			}
		);
	}
	
	close() {
		this.dialogRef.close(undefined);
	}
	
}